import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { PlayersList, Player, PlayerName } from './MultiPlayerSelector.styles';

export default ({value, onChange}) => {

    const [selecteds, setSelecteds] = useState(value || []);
    const participants = useSelector(state => state.playersState.participants);

    useEffect(() => {
        if (typeof onChange === 'function') {
            onChange(selecteds);
        }
    }, [selecteds, onChange]);
    
    
    const toggleSelection = (playerId) => {
        setSelecteds(pId => {
            let index = pId.indexOf(playerId);

            if (index === -1) {
                return [...pId, playerId];
            } else {
                pId.splice(index, 1);
                return [...pId];
            }
        });
    }

    return <PlayersList className='scrollbar'>
        {participants && participants.map((p) => <Player className={selecteds.includes(p._id) ? 'selected' : ''} key={p._id} onClick={(e) => {toggleSelection(p._id)}}>
            <PlayerName>{p.name}</PlayerName>
        </Player>)}
    </PlayersList>
};